import type { SVGProps } from 'react';

const SvgAdultOutlinedLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M7.91738 8C7.41151 8 7 8.37302 7 8.83158C7 9.29033 7.41151 9.66335 7.91738 9.66335C8.1586 9.66335 8.16275 9.71373 8.16503 9.73687V15.1684C8.16503 15.627 8.57653 16 9.08241 16C9.58849 16 10 15.627 10 15.1684V9.73688C10 9.0386 9.44538 8 7.91738 8Z'
      fill='currentColor'
    />
    <path
      d='M14.0001 8.00001C12.3457 8.00001 11 9.3206 11 10.9439C11 12.3745 12.0457 13.5688 13.4262 13.8324L12.7848 14.6679C12.6486 14.8454 12.591 15.0642 12.6226 15.2844C12.6542 15.5044 12.7711 15.6992 12.9519 15.8328C13.1 15.9423 13.2761 16 13.4613 16C13.7303 16 13.9773 15.8795 14.139 15.6691L16.3668 12.7669C16.3939 12.7316 16.4154 12.6936 16.4362 12.6553C16.7895 12.1724 17 11.5824 17 10.9439C17 9.32059 15.6543 8.00001 14.0001 8.00001ZM14.0001 12.2245C13.2805 12.2245 12.695 11.6499 12.695 10.9439C12.695 10.2379 13.2805 9.66336 14.0001 9.66336C14.7195 9.66336 15.305 10.2379 15.305 10.9439C15.305 11.6499 14.7195 12.2245 14.0001 12.2245Z'
      fill='currentColor'
    />
    <path
      d='M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z'
      stroke='currentColor'
      strokeLinejoin='round'
    />
  </svg>
);
export default SvgAdultOutlinedLt;
